export enum RouteKeys {
  Home = '/',
  Status = '/404',
  CryptoDashboard = '/dashboards/crypto',
  NotFound = '404',
  NotFoundStatus = '500',
  Maintenance = 'maintenance',
  ComingSoon = 'coming-soon',
  Dashboard = 'dashboards',
  EmployeeDashboard = 'employeeDashboards',
  SurveyorDashboard = 'surveyorDashboards',
  Transactions = 'transactions',
  Crypto = 'crypto',
  Messenger = 'messenger',
  Details = 'details',
  Settings = 'settings',
  StatusPath = 'status',
  Overview = 'overview',
  TemplatePreview = 'template-preview/*',
  Branch = 'branch',
  Users = 'users',
  Permissions = 'permissions',
  Feature = 'feature',
  StaticForms = 'staticForms',
  // Tasks = 'tasks',
  InsuranceClause = 'insurance-clause',
  InsuranceComapny = 'insurance-company',
  PresignedUrl = 'presigned-url',
  // EnquiryNotes = 'enquiry-notes/*',
  InsuranceType = 'insuranceCategory',
  InsuranceCompanyBranch = 'insurance-company/insurance-Branch/*',
  InsuranceCompanyClause = 'insurance-Clause/*',
  InsuranceCompanyBranchBankAccount = 'insurance-company/insurance-Branch/insuranceBankAccount/*',
  IcbContacts = 'insurance-company/insurance-Branch/branchContacts/*',
  RolePermissions = 'rolePermissions',
  PolicyProducts = 'policyProducts',
  PolicyProductsBrokerage = 'policy-Brokerage/*',
  Kudumbashree = 'kudumbashree',
  Customer = 'customer',
  ProductClauses = 'productClauses',
  CustomerLeads = 'customerLeads',
  Grades = 'grades',
  Zones = 'zones',
  Gross = 'gross',
  Enquiries = 'enquiries',
  NewsletterSettings = 'newsletterSettings',
  CompanyUsers = 'insurance-company/insurance-Branch/companyUsers/*',
  Departments = 'departments/*',
  Department = 'department',
  MasterInputFields = 'masterInputFields',
  Forms = 'forms',
  Workflows = 'workflows',
  EnquiryDetailing = 'enquiryDetailing/*',
  Master = 'master',
  Industry = 'industry',
  Occupancy = 'occupancy',
  InsuranceCategoryZone = 'insuranceCategoryZone',
  InsuranceZone = 'insuranceZone',
  ClientCompanyPremise = 'corporateCustomers/corporateCustomerBranch/clientCompanyPremise/*',
  EventCalendar = 'calendar',
  Calendar = 'eventCalendar',
  S3FileUpload = 'S3FileUpload',
  Leads = 'Leads',
  WorkflowMapping = 'WorkflowMapping',
  Tasks = 'tasks',
  Holidays = 'holidays',
  BlockIP = 'blockIP',
  TaskView = 'tasks/taskView/*',
  Requirements = 'requirements',
  RfqOld = 'requirements/requestForQuotation/*',
  RequirementView = 'requirements/*',
  RequirementTaskView = 'requirements/taskView/*',
  RequirementNotes = 'requirements/notesView/*',
  EnquiryAddNotes = 'enquiries/notesView/*',
  TaskNotes = 'task/notesView/*',
  EventLog = 'eventLog',
  MailLog = 'mailLog',
  PasswordReset = 'passwordReset',
  ThirdPartyAdministrator = 'thirdPartyAdministrator',
  Stages = 'stages',
  TpaUser = 'thirdPartyAdministrator/tpaBranch/tpaUser/*',
  TpaBranch = 'thirdPartyAdministrator/tpaBranch/*',
  TpaContact = 'thirdPartyAdministrator/tpaBranch/tpaContact/*',
  Category = 'category',
  Subcategory = 'subcategory',
  Article = 'article',
  Scores = 'scores',
  Orders = 'orders',
  Policies = 'policies',
  PolicyRenewal = 'policy-renewals',
  States = 'states',
  District = 'district',
  PolicyReports = 'policyReports',
  RfqReports = 'rfqReports',
  PolicyClaimsReport = 'policy-claims-report',
  RequestForQuotation = 'requestForQuotation',
  Offers = 'offers',
  DynamicConfigurations = 'dynamicConfigurations',
  SessionExpired = 'sessionExpired',
  Surveyor = 'surveyor',
  PolicyClaims = 'policyClaims',
  PolicyClaimsQC = 'policyClaimsQc',
  ClaimTemplates = 'ClaimTemplates',
  RequirementClaimRequests = 'requirements/claim-requests/*',
  Logout = 'logout',
  Questions = 'questions',
  Questionnaire = 'questionnaire',
  QuestionnaireResponse = 'assessmentsResponseList/*',
  Assessments = 'assessments',
  AssessmentsSummaryList = 'summaryListAsssessment',
  AssessmentsResponse = 'assessmentsResponse',
  RegistrationSuccess = 'registrationSuccess',
  Rfq = 'rfq',
  CorporateCustomers = 'corporateCustomers',
  CorporateCustomersBranch = 'corporateCustomers/corporateCustomerBranch/*',
  CorporateCustomersBankAccount = 'corporateCustomers/corporateCustomerBranch/corporateCustomerBankAccount/*',
  CorporateCustomerPremise = 'corporateCustomers/corporateCustomerBranch/corporateCustomerPremise/*',
  Wallet = 'corporateCustomers/wallet/*',
  ReailCustWallet = 'retailCustomers/wallet/*',
  //New Features
  policyProductsTemplate = 'policyProductsTemplate/*',
  headerManagement = 'header-management',
  CreateRFQ = 'create-rfq',
  Organogram = 'organogram',
  Messenger1 = 'messenger1',
  MachineType = 'machineType',
  Voyage = 'voyage',
  VehichleType = 'vehichleType',
  ProductRate = 'productRate',
  Occupation = 'occupation',
  QcApproval = 'qcApproval',
  RfqQcApproval = 'rfqQcApproval',
  RfqEventLog = 'rfq-event-log',
  RfqEventHistory = 'rfq-event-history',
  EndoresementHistory = 'endorsement-history',
  WelcomeMailPasswordReset = 'welcomeMailPasswordReset',
  Placement = 'placement',
  RfqDetails = 'rfqDetails',
  CreateOffer = 'createOffer',
  RfqView = 'rfq-view/*',
  OtpVerification = 'otp-Verification',
  LorDocUploadOtpView = 'claims-otpVerification',
  ViewRfq = 'viewRfq/*',
  Bank = 'bank',
  BranchByBank = 'bank/branch/*',
  PlacementSlip = 'slips',
  GeneratedOffers = 'generatedOffers/*',
  AgeSettingsList = 'age-settings',
  SectionSettingsList = 'section-settings',
  OthersSettingsList = 'others',
  EndoresementSubTypes = 'endoresement-sub-types',
  Endorsement = 'endorsement-list',
  EndorsementShareList = 'endorsement-share',
  EndorsementLists = 'endorsementLists/*',
  EndorsementInsurerLists = 'endorsementInsurerLists/*',
  EndorsementDraftShareList = 'EndorsementDraftShareList',
  CustomerGroup = 'customer-group',
  RfqCancelReason = 'rfq-cancel-reason',
  VehicleMake = 'vehicle-make',
  VehicleModel = 'vehicle-make/vehicle-model/*',
  VehicleVariant = 'vehicle-make/vehicle-model/vehicle-variant/*',
  CustomerLocation = 'customer/locations/:id',
  Brokerage = 'brokerage',
  InvoicePayment = 'invoice-payment',
  Reward = 'reward',
  RewardPayment = 'reward-payment',
  TDS = 'tds',
  TaxPeriodSetting = 'period-tax-setting',
  Tax = 'tax',
  PolicyStatusReport = 'policy-status-report',
  PolicyRenewalReport = 'policy-renewal-report',
  PolicyReportOne = 'policy-report-1',
  PolicyReportTwo = 'policy-report-2',
  PlacementReport = 'placement-report-1',
  PlacementReportTwo = 'placement-report-2',
  PolicyLod = 'policy-list-of-documents',
  GeneratedInvoice = 'generatedInvoice',
  GeneratedRewardInvoice = 'generatedRewardInvoice',
  MisReport = 'MIS-report0',
  MisReport1 = 'MIS-report1',
  MisReport2 = 'MIS-report2',
  InvoiceStatusReport = 'invoiceStatus-report',
  InvoicingReport = 'invoicing-report',
  InvoicingHistory = 'invoiceHistory',
  RewardHistory = 'rewardHistory',
  GenerateInvoice2 = 'generateInvoice2',
  LeadsReport = 'lead-report',
  IrdaiForms = 'IrdaiForms',
  BrokerageReconciliation = 'ReconciliationBrokerage',
  // AddNotes = 'notes/*'
  ExcessDeductible = 'excess-deductible',
  UpdateCoInsurance = 'update-co-insurance',
  InvoiceReceivable = 'invoiceReceivable',
  EndorsementStatusReport = 'endorsement-status-report',
  InvoiceGstReport = 'invoiceGstReport',
  TransactionWiseReceivableReport = 'transactionWiseReceivableReport',
  BusinessReport = 'businessReport',
  InsuranceCompanyWallet = 'insuranceCompanyWallet',

  ClaimTpa = 'claimTpa',
  ClaimSurveyor = 'claimSurveyor',
  ClaimSurveyorType = 'claimSurveyorType',
  ClaimSubType = 'claimSubType',
  Hospital = 'hospital',
  RejectionReason = 'rejectionReason',
  FieldMaster = 'fieldMaster',
  MasterData = 'masterData',
  BusinessBRReport = 'businessBRReport',
  BrokerageAdjustmentEndorsement = 'brokerageAdjustmentEndorsement',
  Currency = 'currency',
  DocumentNames = 'document-names',
  EmailMaster = 'email-master'
}
